export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/local-storage-service-stack-form';
